import styled from 'styled-components';

import { colors } from './styles/theme';

export const Container = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`;

export const HelpButton = styled.a`
  z-index: 10;
  position: fixed;
  bottom: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: none;
  background-color: ${colors('accent.base')};
  color: ${colors('accent.text')};
  text-align: center;
  text-transform: uppercase;
  border-radius: 30px;
  text-decoration: none;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.12);
  transition: 0.3s;

  &:hover,
  &:focus {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }
`;
